import React, { useEffect } from 'react';
import { di } from '../../../state/inversify.config';
import { ConneqtNewPlayerDomain } from './conneqtNewPlayer.domain';
import { AddPlayerModal } from '../../players/addPlayerModal/addPlayer.modal';

interface AddPlayerModalProps {
  showAddPlayerModal: boolean;
  setShowAddPlayerModal: (value: boolean) => void;
}
export function AddNewPlayerModal({
  showAddPlayerModal,
  setShowAddPlayerModal,
}: AddPlayerModalProps) {
  const conneqtNewPlayerDomain = di.get(ConneqtNewPlayerDomain);

  const pendingConneqtId =
    conneqtNewPlayerDomain.usePendingPlayerCreationConneqtId();

  const pendingPlayerCreationInputs =
    conneqtNewPlayerDomain.usePendingPlayerCreationCluesAsInputs();

  useEffect(() => {
    if (pendingConneqtId) setShowAddPlayerModal(true);
  }, [pendingConneqtId, setShowAddPlayerModal]);

  const onClose = () => {
    setShowAddPlayerModal(false);
    conneqtNewPlayerDomain.dispatchNoLongerPending();
  };

  return (
    <AddPlayerModal
      showAddPlayerModal={showAddPlayerModal}
      onClose={onClose}
      dispatchCreatePlayer={conneqtNewPlayerDomain.dispatchCreatePlayer}
      setShowAddPlayerModal={setShowAddPlayerModal}
      initialValues={pendingPlayerCreationInputs}
    />
  );
}
